import { Box, Flex, Grid, Skeleton, Text, Image, Badge } from '@mantine/core';
import type { ComponentPropsWithoutRef, FC } from 'react';
import GreenDot from './GreenDot';
import YellowDot from './YellowDot';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/RoutesName';
import { useFoodItemsCardStyles } from './styles';
import { DummyImage } from '../../assets';
import RedDot from './RedDot';

type Props =
  | {
      type: 'loading';
    }
  | {
      type: 'regular';
      data: any;
      restaurantInfo: {
        restaurantName: string;
        rating: number;
        ratingCount: number;
        openingHours: string;
        fullAddress: string;
      };
    };

const FoodItemsCard: FC<Props> = (props) => {
  const navigate = useNavigate();
  const { classes, cx } = useFoodItemsCardStyles();

  const onClickHandler = () => {
    if (props.type === 'regular' && props.data.is_available_now) {
      navigate(`${ROUTES.ADDITEM}`, {
        state: {
          restaurantInfo: props.restaurantInfo,
          foodInfo: props.data,
        },
      });
    }
  };

  return (
    <>
      <Box
        onClick={onClickHandler}
        className={
          props.type === 'regular' && !props.data.is_available_now ? classes.containerDisable : classes.containerEnable
        }>
        <Grid p={0} m={0}>
          <Grid.Col p={0} m={0} className={cx(classes.genericGridCol, classes.firstGridCol)}>
            <Box w='100%' h='100%'>
              {props.type === 'loading' ? (
                <Skeleton width='100%' height={75} />
              ) : (
                <Image src={props.data.image_url || DummyImage} radius={12} width={'100%'} height={75} />
              )}
            </Box>
          </Grid.Col>

          <Grid.Col className={cx(classes.genericGridCol, classes.secondGridCol)}>
            <Flex direction='column' gap={16} justify='center' h={'100%'} p={8}>
              {props.type === 'loading' ? (
                <Skeleton height={14} width={'40%'} />
              ) : (
                <Text fz={14} fw={500} lh={1} lineClamp={1}>
                  {props.data.name}
                </Text>
              )}

              <Flex gap={32}>
                {props.type === 'loading' ? (
                  <>
                    <Skeleton height={12} width={'35%'} /> <Skeleton height={12} width={'35%'} />
                  </>
                ) : (
                  <>
                    <Flex gap={4} align='center'>
                      {props.data.diet.diet_id === 3 ? <RedDot /> : <GreenDot />}
                      <Text fz={12} lh={1} fw={500} c='dimmed'>
                        {props.data.diet.name}
                      </Text>
                    </Flex>

                    <Flex gap={4} align='center'>
                      <YellowDot />
                      <Text fz={12} lh={1} fw={500} c='dimmed'>
                        {props.data.calories} Cal
                      </Text>
                    </Flex>
                  </>
                )}
              </Flex>
            </Flex>
          </Grid.Col>
          <Grid.Col className={cx(classes.genericGridCol, classes.thirdGridCol)}>
            <Flex direction='column' gap={16} justify='center' align='center' h='100%'>
              {props.type === 'loading' ? (
                <Skeleton h={18} w={'100%'} />
              ) : (
                <Text fz={18} fw={500} c='red' lh={1} ta='center'>
                  ${parseFloat(props.data.price).toFixed(2)}
                </Text>
              )}

              {props.type === 'loading' ? (
                <Skeleton h={21} w={'100%'} />
              ) : (
                <Box
                  style={{
                    border: '1px solid #D61D4F',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '80%',
                    padding: 4,
                    borderRadius: 8,
                  }}>
                  <Text fz={11} lh={1} c='magenta.9' fw={600}>
                    Details
                  </Text>
                </Box>
              )}
            </Flex>
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

export default FoodItemsCard;
